export const articleList = [
  {
    id: 1,
    title: '2025年十大必备办公软件推荐，提升工作效率的利器',
    excerpt: '随着远程办公和混合办公模式的普及，选择高效的办公软件变得至关重要。本文精选了10款2025年最值得安装的办公效率工具，从文档处理到项目管理，帮你事半功倍。',
    content: `在数字化转型的浪潮中，办公软件已成为现代职场人不可或缺的生产力工具。2025年，AI技术的深度融合让办公软件焕发出全新的活力。

## WPS Office - 国产办公套件的标杆

WPS Office在2025年持续领跑国产办公软件市场。其AI智能写作功能可以一键生成工作总结、PPT大纲和数据分析报告。云端协作支持百人同时在线编辑，兼容Microsoft Office全格式，是替代传统办公套件的最佳选择。

## 腾讯会议 - 远程协作的首选

后疫情时代，腾讯会议凭借稳定的连接质量和完善的功能生态，稳居视频会议工具榜首。虚拟背景、AI实时字幕、会议纪要自动生成等功能，让远程沟通如同面对面。

## Notion - 知识管理的新范式

Notion将笔记、数据库、看板、日历融为一体，打造了全新的知识管理体验。2025年推出的AI助手可以自动整理笔记、生成摘要和翻译内容，成为个人和团队的知识中枢。

## 钉钉 - 企业数字化的核心枢纽

钉钉已从单一的IM工具演进为企业数字化办公平台。低代码应用搭建、智能审批流、企业云盘等功能，让中小企业也能快速实现数字化转型。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20on%20wooden%20desk%2C%20clean%20and%20bright%20environment%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%20style%20with%20subtle%20shadows%2C%20elegant%20composition&width=800&height=450&seq=article-cover-01&orientation=landscape',
    category: '软件推荐',
    author: '91下载编辑部',
    publishDate: '2025-06-15',
    readCount: '12,860',
    tags: ['办公软件', '效率工具', '推荐'],
    relatedIds: [7, 9, 3],
  },
  {
    id: 2,
    title: '电脑安全防护指南：如何选择适合自己的杀毒软件',
    excerpt: '网络安全威胁日益严峻，一款可靠的杀毒软件是电脑的第一道防线。本文从防护能力、系统占用、功能丰富度等维度，帮你理性选购杀毒软件。',
    content: `在数字化时代，电脑安全防护已经不再是可有可无的选项，而是每个用户的必修课。

## 为什么需要杀毒软件

2025年的网络威胁更加复杂多样。勒索软件、钓鱼攻击、挖矿病毒层出不穷。Windows自带的Defender虽然有了长足进步，但在面对高级威胁时仍显不足。

## 火绒安全 - 轻量级防护典范

火绒安全以极低的系统资源占用和强大的弹窗拦截能力赢得了口碑。它的HIPS（主机入侵防御系统）可以精准拦截恶意行为，安静守护电脑安全，不会像某些杀软那样频繁弹出广告。

## 安全防护最佳实践

除了安装杀毒软件，我们还建议你：
- 保持操作系统和应用软件及时更新
- 不使用来源不明的U盘和外部设备
- 定期备份重要数据
- 开启防火墙和实时防护
- 谨慎点击邮件中的链接和附件

网络安全是一场持久战，选择合适的工具只是第一步。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20shield%20symbol%20and%20lock%20icons%2C%20clean%20minimal%20composition%20on%20light%20background%2C%20subtle%20green%20and%20warm%20gray%20color%20palette%2C%20modern%20tech%20aesthetic%2C%20soft%20gradients%2C%20professional%20corporate%20style&width=800&height=450&seq=article-cover-02&orientation=landscape',
    category: '安全指南',
    author: '91下载安全团队',
    publishDate: '2025-06-10',
    readCount: '8,920',
    tags: ['安全', '杀毒', '指南'],
    relatedIds: [1, 5, 4],
  },
  {
    id: 3,
    title: 'AI视频剪辑工具横评：剪映 vs PR vs 必剪，谁更适合你',
    excerpt: '短视频时代，人人都需要一款好用的视频剪辑工具。我们将三款主流视频剪辑软件从功能、易用性、素材丰富度等方面进行全面对比。',
    content: `短视频创作已经成为内容生产的主流方式。面对市场上琳琅满目的剪辑工具，如何选择最适合自己的那一款？

## 剪映专业版 - 入门到精通的万能选手

剪映凭借AI字幕自动生成、智能抠像、海量模板素材等功能，在2025年依然保持着视频剪辑工具的头把交椅。它降低视频创作门槛，让零基础用户也能快速产出高质量内容。

## Adobe Premiere Pro - 专业创作者的选择

PR作为行业标准，在色彩管理、多机位剪辑、插件生态方面有着不可替代的优势。但较高的学习成本和订阅费用让不少初学者望而却步。

## 必剪 - B站创作者的专属工具

必剪深度整合B站生态，一键投稿、热门梗素材、弹幕互动等功能让它成为B站UP主的最爱。

综合来看，普通用户推荐剪映，专业用户选PR，B站创作者用必剪。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20video%20editing%20workspace%20with%20timeline%20interface%20and%20colorful%20visual%20elements%2C%20modern%20minimal%20design%2C%20clean%20composition%20with%20warm%20lighting%2C%20professional%20creative%20studio%20atmosphere%2C%20subtle%20orange%20and%20teal%20accents&width=800&height=450&seq=article-cover-03&orientation=landscape',
    category: '评测对比',
    author: '91下载编辑部',
    publishDate: '2025-06-05',
    readCount: '15,340',
    tags: ['视频剪辑', 'AI', '横评'],
    relatedIds: [1, 6, 2],
  },
  {
    id: 4,
    title: '程序员必备的10款开发工具，每一款都值得安装',
    excerpt: '工欲善其事必先利其器，优秀的开发工具能极大提升编程效率。本文为开发者整理了10款2025年最值得使用的开发工具。',
    content: `无论是前端、后端还是全栈开发者，一套趁手的开发工具链都是高效工作的基础。

## Visual Studio Code - 编辑器之王

VS Code凭借丰富的插件生态和出色的性能表现，已经成为全球最受欢迎的代码编辑器。GitHub Copilot的深度整合更是让它如虎添翼。

## 更多工具推荐

- **Git**：版本控制的不二之选
- **Postman**：API调试利器
- **Docker**：容器化部署必备
- **Figma**：UI设计协作工具
- **Terminal**：命令行效率神器`,
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20developer%20workspace%20with%20code%20editor%20on%20screen%2C%20minimal%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20professional%20tech%20environment%2C%20dark%20theme%20code%20interface%2C%20stylish%20coffee%20shop%20coding%20atmosphere&width=800&height=450&seq=article-cover-04&orientation=landscape',
    category: '软件推荐',
    author: '91下载技术团队',
    publishDate: '2025-05-28',
    readCount: '9,450',
    tags: ['开发工具', '编程', '推荐'],
    relatedIds: [3, 7, 1],
  },
  {
    id: 5,
    title: '2025年暑期必玩游戏推荐：从独立精品到3A大作',
    excerpt: '暑期将至，是时候为自己准备一份游戏清单了。我们精选了10款风格各异、类型多样的游戏，覆盖独立精品和3A大作，总有一款适合你。',
    content: `游戏是放松身心、释放压力的最佳方式之一。2025年的游戏市场精彩纷呈。

## 原神 - 开放世界的东方美学

原神以精美的二次元画风和广阔的开放世界征服了全球玩家。七国探索的旅程仍在继续，每一次版本更新都带来全新的冒险体验。

## 英雄联盟 - 永不过时的竞技经典

作为全球最受欢迎的电竞项目，英雄联盟的魅力经久不衰。新赛季的装备改动和英雄重做为老玩家带来新鲜感，也让新手能找到属于自己的英雄。

## Steam独立游戏推荐

独立游戏市场在2025年涌现出大量创意佳作。《动物井》、《小丑牌》等作品证明了游戏性的重要性远大于画面。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20game%20controller%20with%20abstract%20gaming%20elements%20floating%20in%20space%2C%20clean%20minimal%20background%20with%20warm%20gradients%2C%20playful%20and%20energetic%20design%2C%20modern%20gaming%20aesthetic%2C%20soft%20lighting%20with%20orange%20and%20teal%20highlights&width=800&height=450&seq=article-cover-05&orientation=landscape',
    category: '游戏推荐',
    author: '91下载游戏频道',
    publishDate: '2025-05-20',
    readCount: '18,720',
    tags: ['游戏', '推荐', '暑期'],
    relatedIds: [2, 4, 1],
  },
  {
    id: 6,
    title: '浏览器大比拼：Chrome vs Edge vs Firefox，谁是最强浏览器',
    excerpt: '浏览器是我们每天使用最多的软件之一。我们将三款主流浏览器从速度、内存占用、扩展生态、隐私保护等方面进行全面对比。',
    content: `浏览器作为通往互联网的大门，其性能直接影响着我们的上网体验。

## Chrome - 扩展生态的王者

Chrome凭借海量扩展和与Google服务的深度整合，稳坐浏览器市场的头把交椅。但较高的内存占用一直是用户诟病的焦点。

## Edge - AI加持的后起之秀

Edge在采用Chromium内核后，兼容性和性能都有了质的飞跃。2025年深度整合的Copilot AI助手，让浏览体验更加智能便捷。

## Firefox - 隐私保护的守护者

Firefox坚持开源和非营利路线，在隐私保护方面有着天然优势。如果你是隐私敏感型用户，Firefox是不二之选。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20modern%20web%20browser%20windows%20floating%20in%20minimal%203D%20space%2C%20clean%20light%20background%20with%20subtle%20shadows%2C%20tech%20comparison%20concept%2C%20professional%20design%2C%20warm%20neutral%20color%20palette%2C%20editorial%20style&width=800&height=450&seq=article-cover-06&orientation=landscape',
    category: '评测对比',
    author: '91下载编辑部',
    publishDate: '2025-05-15',
    readCount: '11,230',
    tags: ['浏览器', '横评', '对比'],
    relatedIds: [5, 1, 3],
  },
];

export const articleCategories = ['全部', '软件推荐', '安全指南', '评测对比', '游戏推荐', '使用教程'];